import React from 'react';
import { Eye } from 'lucide-react';
import { Toggle } from '../ui/toggle';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Section, FormField } from './InspectionShared';

const OverviewSection = ({ formData, setFormData, toggleArray, handleSectionPhoto }) => {
  return (
    <Section title="Inspection Overview" icon={<Eye className="h-6 w-6 text-indigo-600" />} onPhoto={handleSectionPhoto}>
      <FormField label="Inspection Type">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
          {['Full Inspection', 'External Only', 'Quick Check', 'Emergency'].map((type) => (
            <Toggle
              key={type}
              pressed={formData.inspection_type?.includes(type)}
              onPressedChange={() => toggleArray('inspection_type', type)}
              data-testid={`inspection-type-${type.toLowerCase().replace(' ', '-')}`}
              className="h-14 data-[state=on]:bg-indigo-600 data-[state=on]:text-white"
            >
              {type}
            </Toggle>
          ))}
        </div>
      </FormField>

      <FormField label="Overall Temperament">
        <Select
          value={formData.temperament}
          onValueChange={(value) => setFormData({ ...formData, temperament: value })}
        >
          <SelectTrigger className="h-14" data-testid="temperament-select">
            <SelectValue placeholder="Select temperament" />
          </SelectTrigger>
          <SelectContent>
            {['Very Calm', 'Calm', 'Moderate', 'Agitated', 'Very Agitated'].map((t) => (
              <SelectItem key={t} value={t}>{t}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </FormField>

      <FormField label="Population Estimate">
        <Select
          value={formData.population}
          onValueChange={(value) => setFormData({ ...formData, population: value })}
        >
          <SelectTrigger className="h-14" data-testid="population-select">
            <SelectValue placeholder="Select population" />
          </SelectTrigger>
          <SelectContent>
            {['Very Small', 'Small', 'Medium', 'Large', 'Very Large'].map((p) => (
              <SelectItem key={p} value={p}>{p}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </FormField>
    </Section>
  );
};

export default OverviewSection;
